import type { User } from '@auth/domain';
import { createAction } from '@reduxjs/toolkit';

/**
 * Clear auth state (logout)
 */
export const clearAuth = createAction('auth/clearAuth');

/**
 * Set user data
 */
export const setUser = createAction<User | null>('auth/setUser');
